import React from 'react';

import styles from './styles.module.css';
import ChangeView from '../ChangeView';
import SearchInput from '@/components/Form/searchInput';

interface SearchHeaderProps {
  floatHeader?: boolean;
  searchPlaceholder: string;
  searchValue: string;
  searchOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  icon?: React.ComponentType<{ className?: string }>;
  title?: string;
  renderTabs?: boolean;
  selected?: string;
  onClickView?: (view: string) => void;
  resetSearch?: () => void;
  showCross?: boolean;
}

export const HeaderIconAndTitle = ({
  Icon,
  title
}: {
  Icon: React.ComponentType<{ className?: string }> | undefined;
  title: string;
}) => (
  <>
    {Icon && <Icon className={styles.locationIcon} />}
    {title && <h1 className={styles.title}>{title}</h1>}
  </>
);
function SearchHeader({
  floatHeader = false,
  searchPlaceholder,
  searchValue,
  searchOnChange,
  icon: Icon,
  title,
  renderTabs = false,
  selected,
  onClickView,
  resetSearch,
  showCross
}: SearchHeaderProps) {
  return (
    <div className={`${styles.header} ${floatHeader && styles.floatHeader}`}>
      <div className={styles.leftSection}>
        <HeaderIconAndTitle Icon={Icon} title={title || ''} />
      </div>

      <div className={styles.centerSection}>
        <SearchInput
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={searchOnChange}
          customClass={styles.searchContainer}
          resetSearch={resetSearch}
          showCross={showCross}
        />
      </div>
      <div className={styles.rightSection}>
        {renderTabs && selected && onClickView && (
          <ChangeView selected={selected} onClickView={onClickView} />
        )}
      </div>
    </div>
  );
}
export default SearchHeader;
